const initialState = {
    id: null,
    role: null,
    username: null,
    setviewer: null,
    setviewer_name: null,
    loading: false,
    error: null
  };
  
  const userReducer = (state = initialState, action) => {

    switch (action.type) {
      case 'LOGIN_SUCCESS':
        return {
          ...state,
          id: action.payload.id,
          role: action.payload.role,
          username: action.payload.username,
          setviewer: action.payload.setviewer,
          setviewer_name: action.payload.setviewer_name,
          loading: true, 
          error: null
        };
      case 'FETCH_USERDATA_REQUEST':
        return { 
          ...state, 
          loading: true, 
          error: null };
      case 'FETCH_USERDATA_SUCCESS':
        return { 
          ...state, 
          id: action.payload.id,
          role: action.payload.role,
          username: action.payload.username,
          setviewer: action.payload.setviewer,
          setviewer_name: action.payload.setviewer_name,
          loading: false, 
          error: null };
      case 'FETCH_USERDATA_FAILURE':
        return { ...state, loading: false, error: action.error };
        case 'FETCH_USERDATA_CLEAR':
          return initialState; // Сбрасываем состояние к изначальному
      default:
        return state;
    }
  };
  
  export default userReducer;